import React from "react";
import "./Carousel.scss";
import SwiperCore, { Keyboard, Mousewheel, Navigation, Pagination, SwiperOptions } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";

SwiperCore.use([Navigation, Pagination, Keyboard, Mousewheel]);

interface CarouselProps {
  swiperSettings: SwiperOptions;
  children: React.ReactNode[];
}

/**
 * Passed children will display as each slide in the carousel
 *
 * @param swiperSettings - object of settings for the carousel
 * @param children - items to display in the carousel
 * @returns Returns carousel items
 *
 */
export const Carousel: React.FC<CarouselProps> = ({ children, swiperSettings }) => {
  const defaultSettings: SwiperOptions = {
    slidesPerView: 2,
    spaceBetween: 50,
    grabCursor: false,
    pagination: true,
    navigation: true,
  };
  const settings = swiperSettings ? swiperSettings : defaultSettings;
  return (
    <Swiper {...settings}>
      {Object.keys(children).length > 0 &&
        children?.map((child, slide_index) => {
          return <SwiperSlide key={slide_index}>{child}</SwiperSlide>;
        })}
    </Swiper>
  );
};

// having our own interface means we can call it through Components and not swiper
export interface CarouselTypes extends Omit<SwiperOptions, "spaceBetween"> {
  id?: string;
  spaceBetween?: number | string;
}
